import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {
    Layout,
    Form,
    Icon,
    Input,
    Button,
    Row,
    Col,
    Spin,
    Alert
} from 'antd';
import AuthService from '../../Components/AuthService';
import UserProvider from '../../js/userProvider';
import packageJson from '../../../package.json';
import './Login.css';
import DataService from '../../Components/Data';

const { Header, Content } = Layout;
const FormItem = Form.Item;

class Login extends Component {

    constructor(props) {
        super(props);
        this.Auth = new AuthService();
        this.dataService = new DataService();
        this.handleSubmit = this.handleSubmit.bind(this);

        this.state = {
            loading: false,
            loadingCliente: true,
            nomeCliente: "",
            imagemCliente: "",
            erro: false,
            msgErro: "",
            autoLogin: false
        }

        this.uiFilial = "";
        this.uiPessoa = "";

        this.userData = UserProvider.getInstance();        
    }

    componentWillMount() {

        if (this.props.location && this.props.location.search && this.props.location.search !== "") {
            this.redirect = this.props.location.search;

            if(this.redirect.indexOf("&uiPessoa=") > -1){

                var pieces = this.redirect.split("&uiPessoa=");                
                this.uiFilial = pieces[0].replace("?uiFilial=", "");
                this.uiPessoa = pieces[1].replace("&uiPessoa=", "");
                
                if(this.uiPessoa.indexOf("&etc=") > -1){
                    var pieces2 = this.uiPessoa.split("&etc="); 
                    this.uiPessoa = pieces2[0];
                }

                this.setState({
                    autoLogin : true
                });

                var dados = {
                    "uiFilial": this.uiFilial,
                    "uiPessoa" : this.uiPessoa
                };

                this.userData.setUiFilial(this.uiFilial);

                this.doLogin(dados);

            }else{
                this.userData.setUiFilial(this.redirect.replace("?uiFilial=", ""));
            }            
        }

        if (this.Auth.loggedIn()) {
            this.props.history.push('/');
        } else {

            if (this.uiFilial === "" || this.uiFilial === null) {
                this.uiFilial = this.userData.getUiFilial();
            }

            if (this.uiFilial === "" || this.uiFilial === null) {
                this.props.history.push('/selecione-radio');
                return
            }

            var dados = {
                "uiFilial": this.uiFilial
            };

            this.dataService.GetDadoPreLogin(dados, (retorno) => {

                this.setState({
                    loadingCliente: false,
                    nomeCliente: retorno.DsEstabelecimento,
                    imagemCliente: retorno.DsUrlImagem.replace(/&amp;/g, '&')
                });

            }, (error) => {

                this.setState({
                    loadingCliente: false
                });

                console.log(error);
            });
        }
    }

    handleSubmit = (e) => {
        e.preventDefault();

        this.setState({ erro: false });

        this.props.form.validateFields((err, values) => {
            if (!err) {


                this.setState({ loading: true });

                var dados = {
                    "uiFilial": this.uiFilial,
                    "dsUsuario": values.userName,
                    "dsSenha": values.password
                };

                this.doLogin(dados);

            }
        });
    }

    doLogin(dados){

        this.dataService.Login(dados, (retorno) => {
            this.setState({ loading: false });

            if (retorno["Status"] == "0") {

                this.setState({
                    erro: true,
                    msgErro: retorno["DsMsg"].replace("&lt;br&gt;&gt;&gt;", "")
                });

            } else {
                this.Auth.login(retorno["DsNome"], retorno["UiPessoa"], retorno)
                    .then(res => {
                        this.props.history.push('/');
                    })
                    .catch(err => {
                        alert(err);
                    })
            }

        }, (error) => {
            console.log(error);
            this.setState({ loading: false });
        });
    }



    render() {

        const { getFieldDecorator } = this.props.form;

        return (

            <Layout className="App" style={{ height: "100vh" }}>
                <Header className="App-header App-header-login" style={{ position: 'fixed', width: '100%', zIndex: 100 }}>
                    Login
                </Header>
                <Content className="contentStyle">

                    {this.state.autoLogin ? (

                        <Row>
                            <Col className="imageRadio">
                                <div className="divSpin">
                                    <Spin className="imageSpin" />
                                </div>
                            </Col>
                        </Row>

                    ) : (

                            <div>
                                <Row>
                                    <Col className="imageRadio">
                                        {this.state.loadingCliente ? (
                                            <div className="divSpin">
                                                <Spin className="imageSpin" />
                                            </div>
                                        ) : (
                                                <img src={this.state.imagemCliente} alt="imageLogo" />
                                            )}
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <h2 className="nomeRadio">{this.state.nomeCliente}</h2>
                                    </Col>
                                </Row>

                                <Form onSubmit={this.handleSubmit} className="login-form">
                                    <FormItem>
                                        {getFieldDecorator('userName', {
                                            rules: [{ required: true, message: 'Insira seu prefixo/utilizador' }],
                                        })(
                                            <Input prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />} placeholder="Prefixo/utilizador" />
                                        )}
                                    </FormItem>
                                    <FormItem>
                                        {getFieldDecorator('password', {
                                            rules: [{ required: true, message: 'Insira sua senha' }],
                                        })(
                                            <Input prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />} type="password" placeholder="Senha" />
                                        )}
                                    </FormItem>
                                    <FormItem>
                                        <Button
                                            type="primary"
                                            htmlType="submit"
                                            className="login-form-button"
                                            loading={this.state.loading}>
                                            Entrar
                                    </Button>
                                    </FormItem>
                                    {this.state.erro &&
                                        <Row className="text-center">
                                            <Col>
                                                <Alert message={this.state.msgErro} type="warning" />
                                            </Col>
                                        </Row>
                                    }
                                </Form>

                                <Row>
                                    <Col className="text-center">
                                        <Link to="/selecione-radio">Selecionar outra rádio</Link>
                                    </Col>
                                </Row>
                            </div>

                        )}


                </Content>
                <div className="versionDiv">v {packageJson.version}</div>
            </Layout>

        )
    }
}

export default Form.create()(Login);


// WEBPACK FOOTER //
// ./src/Pages/Login/Login.js